// extracted by mini-css-extract-plugin
export default {"button":"SortBy_button__xxA3B"};